import script from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=79ad0c41&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_version_3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ad0c41"]])

export default __exports__